import { ButtonBase, Icon } from '@material-ui/core';
import { PageHeader } from '../../../../components';
import { useState } from 'react';
import { useScreen } from 'usehooks-ts';
import { ExpandedMenuItem, MenuItem } from 'components/Icons/MenuIcon';
import { MobileDashboardFilters } from './MobileFilters';
import { Line, MainContentWrapper, Wrapper } from 'components/HeaderUI';
import { AuctionTabs } from '../../../../components/AuctionTabs';
import { useDispatch, useSelector } from 'react-redux';
import { setAuctionTypeFilter } from '../../../../services/mySales/salesSlice';

const Header = () => {
  const [expanded, setIsExpanded] = useState(false);
  const { width } = useScreen();
  const isMobile = width < 567;

  const { filters } = useSelector(state => state.mySales);

  const dispatch = useDispatch();

  const toggleExpanded = () => setIsExpanded(!expanded);
  const selectTab = tab => dispatch(setAuctionTypeFilter(tab));

  return (
    <>
      <div style={{ height: '76px' }} />
      <Wrapper withBottomMargin isMobileExpanded={expanded && isMobile}>
        <MainContentWrapper>
          <AuctionTabs
            paddings={isMobile ? 'md' : 'lg'}
            fontSize={isMobile ? 'md' : 'lg'}
            selectTab={selectTab}
            selectedTab={filters.auctionType}
            hideNonActive
          />
          <span className="flex-grow" />
          <ButtonBase onClick={() => {}}>
            <Icon>refresh</Icon>
          </ButtonBase>
          {isMobile && (
            <ButtonBase onClick={toggleExpanded}>{expanded ? <ExpandedMenuItem /> : <MenuItem />}</ButtonBase>
          )}
        </MainContentWrapper>
        {isMobile && expanded && <Line />}
        {isMobile && expanded && <MobileDashboardFilters />}
      </Wrapper>
    </>
  );
};

export default Header;
